import telaRosaAzul from "../../assets/tela-rosa-azul.png";

function BottomPink() {
  return (
    <div className="flex items-center justify-center">
      <img
        alt="imagem inferior"
        className="img-bottom pt-0 pb-20 sm:px-6 lg:px-8"
        src={telaRosaAzul}
      />
    </div>
  );
}

export default BottomPink;
